import Layout from "../../components/Layout";
import NavHeader from "../../components/NavHeader";
import ScrollToTop from "../../components/ScrollToTop";
import SessionCheck from "../../components/SessionCheck";
import SmartHomeComponent from "../../sections/SmartHome";
import Solar from "../../sections/Solar/index"

const Index = () => {
  return (
    <Layout>
      <ScrollToTop />
      <SessionCheck shouldRedirect />
      <NavHeader pageTitle="Smart Home Services" routeName="Smart Home Services" />
      <SmartHomeComponent/>
    </Layout>
  );
};

export default Index;